import { computed } from 'vue'
import { can } from '@/lib/permissions/can'
import { Permission } from '@/lib/permissions/keys'
import { useWorkspaceStore } from '@/stores/workspace'

/** Billing is an organization-level grant on the backend; a workspace-level one isn't enough. */
export function useCanViewBilling() {
  const workspace = useWorkspaceStore()

  return computed(() => {
    const organizationId = workspace.currentOrganizationId

    return organizationId !== null && can(Permission.BillingGet, { organizationId })
  })
}
